import { parsePhoneNumberFromString } from 'libphonenumber-js';

// North American Numbering Plan countries use parentheses convention
const NANP_COUNTRIES = ['US', 'CA', 'PR', 'VI', 'GU', 'AS', 'MP'];

export default function formatPhone(phoneNumber: string | null | undefined): string {
  if (!phoneNumber) {
    return '';
  }

  const parsed = parsePhoneNumberFromString(phoneNumber);

  if (!parsed) {
    return phoneNumber;
  }

  // Use parentheses format for North American numbers: +1 (212) 351-6980
  if (parsed.country && NANP_COUNTRIES.includes(parsed.country)) {
    const national = parsed.formatNational(); // (212) 351-6980
    return `+${parsed.countryCallingCode} ${national}`;
  }

  // Use standard international format for other countries
  return parsed.formatInternational();
}
